var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "border" }, [
    _c("div", { staticClass: "loan-row" }, [
      _c(
        "div",
        { staticClass: "item" },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "loanPlatformId",
                rules: {
                  required: true,
                  message: "请填写该项",
                  trigger: "blur"
                }
              }
            },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.loanPlatformList,
                  "menu-props": { bottom: true, offsetY: true },
                  label: "贷款平台",
                  "item-text": "loanPlatformName",
                  "item-value": "id",
                  outlined: "",
                  dense: true,
                  height: 42,
                  clearable: true,
                  "clear-icon": "$clear",
                  "hide-details": "auto",
                  "no-data-text": "暂无数据"
                },
                model: {
                  value: _vm.loanInfoForm.loanPlatformId,
                  callback: function($$v) {
                    _vm.$set(_vm.loanInfoForm, "loanPlatformId", $$v)
                  },
                  expression: "loanInfoForm.loanPlatformId"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "item" },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "loanIouNo",
                rules: {
                  required: true,
                  message: "请填写该项",
                  trigger: "blur"
                }
              }
            },
            [
              _c("v-text-field", {
                attrs: {
                  label: "贷款借据号",
                  outlined: "",
                  dense: true,
                  height: 42
                },
                model: {
                  value: _vm.loanInfoForm.loanIouNo,
                  callback: function($$v) {
                    _vm.$set(_vm.loanInfoForm, "loanIouNo", $$v)
                  },
                  expression: "loanInfoForm.loanIouNo"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "item" },
        [
          _c(
            "el-form-item",
            {
              staticStyle: { width: "282px", "margin-bottom": "0" },
              attrs: {
                prop: "loanRefundTime",
                rules: {
                  required: true,
                  message: "请填写该项",
                  trigger: "blur"
                }
              }
            },
            [
              _c(
                "v-menu",
                {
                  ref: "menu",
                  attrs: {
                    "close-on-content-click": false,
                    "return-value": _vm.loanInfoForm.loanRefundTime,
                    transition: "scale-transition",
                    "offset-y": "",
                    "min-width": "auto"
                  },
                  on: {
                    "update:returnValue": function($event) {
                      return _vm.$set(
                        _vm.loanInfoForm,
                        "loanRefundTime",
                        $event
                      )
                    },
                    "update:return-value": function($event) {
                      return _vm.$set(
                        _vm.loanInfoForm,
                        "loanRefundTime",
                        $event
                      )
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        var attrs = ref.attrs
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              _vm._b(
                                {
                                  attrs: {
                                    label: "退贷日期",
                                    "hide-details": "auto",
                                    outlined: "",
                                    dense: true,
                                    height: 42,
                                    clearable: true,
                                    readonly: ""
                                  },
                                  model: {
                                    value: _vm.loanInfoForm.loanRefundTime,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.loanInfoForm,
                                        "loanRefundTime",
                                        $$v
                                      )
                                    },
                                    expression: "loanInfoForm.loanRefundTime"
                                  }
                                },
                                "v-text-field",
                                attrs,
                                false
                              ),
                              on
                            )
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.menu,
                    callback: function($$v) {
                      _vm.menu = $$v
                    },
                    expression: "menu"
                  }
                },
                [
                  _c(
                    "v-date-picker",
                    {
                      attrs: { "no-title": "", locale: "zh-cn" },
                      model: {
                        value: _vm.loanInfoForm.loanRefundTime,
                        callback: function($$v) {
                          _vm.$set(_vm.loanInfoForm, "loanRefundTime", $$v)
                        },
                        expression: "loanInfoForm.loanRefundTime"
                      }
                    },
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "primary" },
                          on: {
                            click: function($event) {
                              _vm.menu = false
                            }
                          }
                        },
                        [_vm._v("取消")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { text: "", color: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.$refs.menu.save(
                                _vm.loanInfoForm.loanRefundTime
                              )
                            }
                          }
                        },
                        [_vm._v(" 确认 ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "loan-row" },
      [
        _c(
          "div",
          { staticClass: "item" },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "loanRefundType",
                  rules: {
                    required: true,
                    message: "请填写该项",
                    trigger: "blur"
                  }
                }
              },
              [
                _c("v-autocomplete", {
                  attrs: {
                    items: [
                      { name: "全部退款", id: 1 },
                      { name: "降贷", id: 2 }
                    ],
                    "menu-props": { bottom: true, offsetY: true },
                    label: "退贷类型",
                    "item-text": "name",
                    "item-value": "id",
                    outlined: "",
                    dense: true,
                    height: 42,
                    clearable: true,
                    "clear-icon": "$clear",
                    "hide-details": "auto",
                    "no-data-text": "暂无数据"
                  },
                  model: {
                    value: _vm.loanInfoForm.loanRefundType,
                    callback: function($$v) {
                      _vm.$set(_vm.loanInfoForm, "loanRefundType", $$v)
                    },
                    expression: "loanInfoForm.loanRefundType"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "item" },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "loanRefundMoney",
                  rules: {
                    required: true,
                    message: "请填写该项",
                    trigger: "blur"
                  }
                }
              },
              [
                _c("v-text-field", {
                  attrs: {
                    label: "贷款退费",
                    autocomplete: "off",
                    outlined: "",
                    dense: true,
                    height: 42,
                    type: "number",
                    suffix: "元"
                  },
                  on: { change: _vm.loanRefundMoneyVerify },
                  model: {
                    value: _vm.loanInfoForm.loanRefundMoney,
                    callback: function($$v) {
                      _vm.$set(_vm.loanInfoForm, "loanRefundMoney", $$v)
                    },
                    expression: "loanInfoForm.loanRefundMoney"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "item" },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  prop: "loanOccupiedinterestMoney",
                  rules: {
                    required: true,
                    message: "请填写该项",
                    trigger: "blur"
                  }
                }
              },
              [
                _c("v-text-field", {
                  attrs: {
                    label: "占用贴息",
                    value: _vm.loanInfoForm.loanOccupiedinterestMoney,
                    disabled: "",
                    outlined: "",
                    dense: true,
                    height: 42,
                    suffix: "元"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "el-tooltip",
          { attrs: { effect: "light", placement: "top-start" } },
          [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _vm._v(
                "1、公司贴息，请在退费计算中添加扣费项目【利息支出】并扣费，占用贴息 = 利息支出扣费总和"
              ),
              _c("br"),
              _vm._v(" 2、学员付息，不需要添加【利息支出】扣费，占用贴息 = 0")
            ]),
            _c("i", {
              staticClass: "el-icon-question",
              staticStyle: { "font-size": "20px", color: "#9BACBF" }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }